import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// mock
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
// import Scrollbar from '../Scrollbar/Scrollbar';
import NavSection from '../Header/NavSection';
import { readLocalStorage } from '@/toolbox/helpers/local-storage-helper';
import { KEY_USER_DATA } from '@/toolbox/constants/local-storage';
import { ROLE_ADMIN, ROLE_SUPERVISOR } from '@/toolbox/constants/role-type';
import { ROLE_SUPER_ADMIN } from '@/toolbox/defaults/static-roles';
import { HeaderView } from '../Header';

// import navConfig from './config';
// import navSubConfigdashboard from './sub-config';

// ----------------------------------------------------------------------

const NAV_WIDTH = 350;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(3, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: '#EDEFF1',
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg', '');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const data_user = readLocalStorage(KEY_USER_DATA);
  const account = {
    photoURL: '#',
    displayName: data_user.user.user_name,
    role: data_user.user.role
  }
  const renderContent = (
     <>
      <HeaderView />
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        {/* logo de la empresa */}
      </Box>

      <Box sx={{ mb: 5, mx: 2.5}}>
        <Link underline="none">
          <StyledAccount>

            <Avatar src={account.photoURL} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              {/* <Typography variant="subtitle2" sx={{ color: 'rgb(24, 144, 255)', }}>
                {account.displayName}
              </Typography> */}

              <Typography variant="body2" sx={{ color: '#3b3b3b', fontWeight:'bolder' }}>
                {account.role}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection />

      <Box sx={{ flexGrow: 1 }} />
     </>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
